

















































































import { defineComponent, getCurrentInstance, onMounted } from "vue";
import { readBoaHora } from "@/utils/programaBoaHora";

export default defineComponent({
  setup() {
    const context = getCurrentInstance().proxy;

    const programs = [
      {
        id: "avaliacao",
        icon: "memo-circle-check",
        title: "Avaliação de saúde",
        description: "Conheça seu perfil de saúde em poucos minutos e receba uma avaliação completa."
      },
      {
        id: "boa-hora",
        icon: "person-pregnant",
        title: "Programa Boa Hora",
        description: "Programa exclusivo da Omint que acompanha você durante a gestação com cuidado e orientações."
      },
      {
        id: "toda-vida",
        icon: "heart",
        title: "Programa Toda Vida",
        description: "Cuidado personalizado para associados Omint com 60 anos ou mais, com foco em suas necessidades."
      }
    ];

    onMounted(() => {
      context.$root.$emit("hide-loading");
    });

    const openProgram = program => {
      if (program.id === "avaliacao") {
        context.$router.push({ name: "programa_saude_2.avaliacao" });
        return;
      }
      if (program.id === "toda-vida") {
        context.$router.push({ name: "programas_de_saude.home" });
        return;
      }
      const record = readBoaHora(context.$store.state.saude.vinculo);
      context.$router.push({
        name: record.joined ? "programa_saude_2.boa_hora.acompanhamento" : "programa_saude_2.boa_hora"
      });
    };

    return { programs, openProgram };
  }
});
